module.exports = __webpack_public_path__ + "media/music/punchy_bass_9-5928dd97.mp3";